import { Link } from 'react-router-dom';
import type {
  PositionBudgetSummary,
  ScholarshipModel,
  ScholarshipPlayer,
} from '../../../../types/scholarships';
import { PitchingStaffCard } from './PitchingStaffCard';
import type { PitchersByThrows } from './pitchingStaff';
import type { DepthChartDisplayMode } from './scholarshipPercent';

interface Props {
  pitchersByThrows: PitchersByThrows;
  scholarshipModel: ScholarshipModel;
  displayMode: DepthChartDisplayMode;
  positionBudgets: PositionBudgetSummary[];
  onClickPlayer: (player: ScholarshipPlayer) => void;
  /** A recruiting board calls its pitching tab Pitchers. */
  recruitingBoard?: boolean;
}

export const PitchingStaffSection = ({
  pitchersByThrows,
  scholarshipModel,
  displayMode,
  positionBudgets,
  onClickPlayer,
  recruitingBoard = false,
}: Props) => (
  <section className="depth-chart-staff" aria-labelledby="staff-section-heading">
    <div className="depth-chart-staff__heading-row">
      <h2 id="staff-section-heading" className="depth-chart-staff__heading">
        {recruitingBoard ? 'Pitchers' : 'Pitching Staff'}
      </h2>
      {/* Roles, arm angles, velo and staff order live on their own tab; this is the summary. */}
      <Link to="../pitching-staff" relative="path" className="depth-chart-staff__link">
        {recruitingBoard ? 'View pitchers' : 'View pitching staff'} (
        {[...pitchersByThrows.RHP, ...pitchersByThrows.LHP].filter((a) => a.appearance === 'primary').length})
      </Link>
    </div>
    <div className="depth-chart-staff__cards">
      <PitchingStaffCard
        label="RHP"
        appearances={pitchersByThrows.RHP}
        scholarshipModel={scholarshipModel}
        displayMode={displayMode}
        positionBudget={positionBudgets.find((b) => b.position === 'RHP')}
        onClickPlayer={onClickPlayer}
      />
      <PitchingStaffCard
        label="LHP"
        appearances={pitchersByThrows.LHP}
        scholarshipModel={scholarshipModel}
        displayMode={displayMode}
        positionBudget={positionBudgets.find((b) => b.position === 'LHP')}
        onClickPlayer={onClickPlayer}
      />
    </div>
  </section>
);
